/* eslint-disable class-methods-use-this */
import axios from 'axios';
import { getAuthToken } from './auth.service';

const headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'POST',
  'Content-Type': 'application/json',
};

class PostHelper {
  async post(url: string, data: any) {
    const response = await axios.post(url, data, { headers });
    return response;
  }

  async formDataPost(url: string, data: any) {
    const formData = new FormData();

    // Append data fields to the FormData object
    for (const key in data) {
      formData.append(key, data[key]);
    }

    const response = await axios.post(url, formData, {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data", // Set the correct content type for FormData
      },
    });

    return response;
  }
}
export default new PostHelper();
